// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__GjvuI","introTitle":"intro_introTitle__JmBRp","introContent":"intro_introContent__R3F7u"};